// Step.jsx
import React, { ReactNode } from 'react';
import '../styles/sdg-selection.css';
import '../styles/step.css';

interface IProps {
  title: string;
  summary?: string;
  description: string;
  children: ReactNode;
}

const Step: React.FC<IProps> = ({ title, summary, description, children }) => {
  return (
    <section className="step-card">
      <header className="step-header">
        <h3 className="step-title">{title}</h3>

        {summary && (
          <p className="step-summary">
            {summary}
          </p>
        )}

        <p className="step-description">
          {description}
        </p>
      </header>

      <div className="step-body">
        {children}
      </div>
    </section>
  );
};

export default Step;
